/* @ngInject */
const myTelInput = (
  $scope
) => {
  return {
    require: 'ngModel',
    restrict: 'E',
    transclude: true,
    priority: 0,
    scope: {
      id: '@myId',
      model: '=ngModel',
    },

    template: require('./myTelInput.html'),

    compile: (scope, element, attrs, ctrl) => {
      $scope.apply()
    },
  }
}

export default myTelInput



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/phone/directives/inputs/myTelInput.js